//
//  index.js
//  Tulip Web Modules SDK
//
//  Export file for Dom directory
//  © 2017 Tulip.
//


// - Internal Dependencies

/// The Dom class from this directory.
export default from './Dom';



// WEBPACK FOOTER //
// ./src/i18n/Dom/index.js